export default __webpack_public_path__ + "static/media/summaryImage.57a5eded.jpg";